import { useTeacherDisplayPreferences } from "../../hooks/useTeacherDisplayPreferences";

export function TemaDisplayShell({ accessibility, children }) {
  const { theme } = useTeacherDisplayPreferences(accessibility);

  return (
    <div
      className="tema-module-root min-h-screen"
      data-teacher-theme={theme}
    >
      {children}
    </div>
  );
}
